import styled from "styled-components";
import { colors, darkModeColors } from "../../consts";

export const DraggingRow = styled.td`
  background: ${darkModeColors.WHITE_RAISIN_100};
`;

export const StaticTableRow = styled.tr`
  background: ${colors.RAISIN_20};
  height: 64px;

  border-radius: 8px;
  outline: 2px solid ${colors.RAISIN_100};

  td {
    padding-left: 16px;
    color: ${colors.RAISIN_100};
  }
`;
